<template>
  <v-btn
    icon="fa:fawsb fa-volume"
    variant="text"
    color="inherit"
    size="small"
    :aria-label="t('button_human_narration')"
    :disabled="disabled"
    @click.stop="playAudio"
    @keydown.enter.stop
    @keydown.space.stop
  />
</template>

<script setup lang="ts">
import { playSound } from '@ilteducation/audio-resources';
import { toRefs } from 'vue';
import axios from 'axios';
import useGamesStore from '../../../use-games';

const props = withDefaults(
  defineProps<{
    audioId: string;
    contentRegistryUrl: string;
    t: CallableFunction;
    disabled: boolean;
  }>(),
  {
    audioId: '',
    contentRegistryUrl: '',
    disabled: false,
  },
);

const { audioId, contentRegistryUrl } = toRefs(props);

const store = useGamesStore();

const playAudio = async () => {
  let audioResource = store.getAudio(audioId?.value);
  if (!audioResource?.url) {
    await axios.get(`${contentRegistryUrl?.value}${audioId?.value}/contentUrls`).then((res) => {
      if (res.data && res.data.url) {
        audioResource = { id: audioId?.value, url: res.data.url };
        store.setAudio(audioResource);
      }
    });
  }

  if (audioResource?.url) {
    playSound(audioResource.url, () => {});
  }
};
</script>
